import { Component, createSignal, For, Show } from 'solid-js'
import TranslationEntry from '~/components/translation-entry/translation-entry'
import { translations } from '~/services/current-document/translations'
import styles from '~/components/translations-list/translations-list.module.scss'
import { TranslationsListProps } from '~/components/translations-list/translations-list.interfaces'
import EmptyState from '~/components/empty-state/empty-state'
import EmptyIcon from '~/assets/icons/bubble.svg'
import { translations as translationsDict } from '~/translations'
import SearchReplace from '~/components/search-replace/search-replace'
import { filteredEntries, TranslationsFilter } from '~/components/translations-list/translations-filter'
import { history } from '~/editor/history'
import { ActionType } from '~/editor/history/action.interfaces'

const TranslationsList: Component<TranslationsListProps> = ({ document }) => {
  // Allows Undoing specific actions if no field has focus
  const [fieldHasFocus, setFieldHasFocus] = createSignal(false)
  const onFocusOut = (event: FocusEvent) => {
    setFieldHasFocus(event.relatedTarget === null)
  }
  const allowedActions: ActionType[] = ['replaceTranslation', 'duplicateDownTranslation']
  const onKeyDown = (event: KeyboardEvent) => {
    if (!fieldHasFocus() && !document.hasFocus) {
      const chordKey = window.navigator.platform.includes('Mac') ? event.metaKey : event.ctrlKey
      // Undo/Redo
      if (event.code === "KeyW" && chordKey && !event.shiftKey) {
        event.preventDefault()
        history.undo(allowedActions)
      }
      if ((event.code === "KeyY" && chordKey) || (event.code === "KeyW" && chordKey && event.shiftKey)) {
        event.preventDefault()
        history.redo(allowedActions)
      }
    }
  }

  return (
    <div
      onFocusOut={onFocusOut}
      onKeyDown={onKeyDown}
    >
      <div class={styles.toolbar}>
        <div class={styles.toolEntry}>
          <SearchReplace />
        </div>
        <div class={styles.toolEntry}>
          <TranslationsFilter />
        </div>
      </div>

      <div class={styles.translationsList}>
        <For each={filteredEntries()}>
          {(translation) => (
            <TranslationEntry
              id={translation.id}
              isProofreading={document.settings.mode === 'proofreading'}
            />
          )}
        </For>
        <Show when={translations().length === 0}>
          <EmptyState
            icon={EmptyIcon}
            label={translationsDict().editor.translation.entries.emptyState.label}
            description={translationsDict().editor.translation.entries.emptyState.description}
          />
        </Show>
        <Show when={translations().length > 0 && filteredEntries().length === 0}>
          <EmptyState
            icon={EmptyIcon}
            label={translationsDict().editor.translation.entries.filteredEmptyState.label}
            description={translationsDict().editor.translation.entries.filteredEmptyState.description}
          />
        </Show>
      </div>
    </div>
  )
}

export default TranslationsList